import camelCaseKeys from 'utils/camelCase'
import log from 'sentry/log'

const parseChannelData = (channel) => {
  let data
  try {
    data = JSON.parse(channel?.data)
  } catch (e) {
    log.message(`Chat: Couldn't parse channel.data. Reason: ${e}`)
  }
  return data
}

const getMembersFromChannelData = (channel) => {
  const { members } = parseChannelData(channel)

  return camelCaseKeys(members) || null
}

export default getMembersFromChannelData
